import api from '../api';

var settings = [
  {
    homepage: {
      zehnder: {
        tabs: {
          installer_companies: true,
          commercial_offers: true,
          filter_shops: true,
          documents: false,
          manage_products: true,
          manage_firmware: true
        }
      },
      installer_company: {},
      installer: {}
    },
    API_HOST:
      typeof window !== 'undefined' && window.backend_comfoair_host
        ? window.backend_comfoair_host
        : 'http://127.0.0.1:8091/',
    title: 'ComfoAir Q',
    customer: 'comfo-air',
    index: 0,
    supportsBeta: true,
    image: require('../public/img/comfoair.png'),
    icons: {
      normal: require('../public/img/comfo-nor.png'),
      hover: require('../public/img/comfo-nor-foc.png'),
      active: require('../public/img/comfo-act.png')
    }
  },
  {
    homepage: {
      zehnder: {
        tabs: {
          installer_companies: true,
          commercial_offers: false,
          filter_shops: false,
          documents: true,
          manage_products: false,
          manage_firmware: false
        }
      },
      installer_company: {},
      installer: {}
    },
    API_HOST:
      typeof window !== 'undefined' && window.backend_evalve_host
        ? window.backend_evalve_host
        : 'http://127.0.0.1:8091/',
    title: 'eValve',
    customer: 'evalve',
    index: 1,
    supportsBeta: false,
    image: require('../public/img/evalve.png'),
    icons: {
      normal: require('../public/img/evalve-nor.png'),
      hover: require('../public/img/evalve-nor-foc.png'),
      active: require('../public/img/evalve-act.png')
    }
  }
];

export function getConfig(store) {
  //Not logged in, no config
  if (!store || !store.login || !store.login.user) {
    return undefined;
  }

  // Try to get it from the store
  if (store.login.config) {
    api.useConfig(store.login.config);
    return store.login.config;
  }

  if (typeof localStorage !== 'undefined') {
    let config = localStorage.getItem('default_config_' + store.login.user.id);
    if (config) {
      config = JSON.parse(config);
      api.useConfig(config);
    }
    return config;
  }
  return undefined;
}
export default settings;



// WEBPACK FOOTER //
// /src/components/settings.js